import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth';
import { environment } from 'src/environments/environment';

@Injectable()
export class RelationshipCategoryService {
  private authToken;
  private company_id;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.company_id = res.companyID));
  }

  private static getRelationshipCategoryListQueryString(queryParams: QueryParamsModel): string {
    const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;
    let fromString = `page=${pageNumber}&size=${pageSize}&sort=${sortField},${sortOrder}`;

    if (filter.searchTerm) {
      fromString += `&term=${filter.searchTerm}`;
    } else {
      if (filter.name) fromString += `&name_has=${filter.name}`;
      if (filter.type) fromString += `&entity_type_has=${filter.type}`;
    }

    return fromString;
  }

  createRelationshipCategory(_item) {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/relation_types/categories`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post<any>(url, _item, { headers });
  }

  findRelationshipCategory(queryParams: QueryParamsModel): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/relation_types/categories`;
    const params = new HttpParams({
      fromString: RelationshipCategoryService.getRelationshipCategoryListQueryString(queryParams),
    });
    return this.http.get<QueryResultsModel>(url, { params });
  }

  searchRelationshipCategory(queryParams: QueryParamsModel, term = ''): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/relation_types/categories?term=${term}`;
    const pageSize = queryParams.pageSize;
    const pageIndex = queryParams.pageNumber;
    const params = new HttpParams({
      fromString: `page=${pageIndex}&size=${pageSize}`,
    });
    return this.http.get<QueryResultsModel>(url, { params });
  }

  searchAutocompleteRelationshipCategory(term = ''): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/relation_types/categories?term=${term}`;
    return this.http.get<QueryResultsModel>(url);
  }

  updateRelationshipCategory(_item): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/relation_types/categories/${_item.id}`;
    return this.http.put<any>(url, _item);
  }

  deleteRelationshipCategory(_itemId: number): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/relation_types/categories/${_itemId}`;
    return this.http.delete<any>(url);
  }
}
